/* ═══════════════════════════════════════════════════════════
   USER STORAGE — User-scoped localStorage key helper.
   Ensures per-user data isolation so logging out and back in
   preserves each user's quiz history, flashcards, AI memory, etc.
   ═══════════════════════════════════════════════════════════ */

let _activeUserId = null;
const _migrated = new Set();

/**
 * Set the currently logged-in user's ID.
 * Call on login/session restore, and null on logout.
 */
export function setActiveUser(userId) {
  _activeUserId = userId || null;
  if (!userId) _migrated.clear();
}

export function getActiveUser() {
  return _activeUserId;
}

/**
 * Returns a user-scoped localStorage key.
 * If a user is active, appends `_${userId}` to the base key.
 * On first access, auto-migrates data from the global (old) key
 * to the user-specific key so existing data isn't lost.
 */
export function userKey(baseKey) {
  if (!_activeUserId) return baseKey;
  const key = `${baseKey}_${_activeUserId}`;

  // One-time migration: copy global key → user-specific key
  if (!_migrated.has(key)) {
    _migrated.add(key);
    try {
      if (!localStorage.getItem(key)) {
        const global = localStorage.getItem(baseKey);
        if (global) localStorage.setItem(key, global);
      }
    } catch {}
  }

  return key;
}
